import { render, staticRenderFns } from "./CompanyClientContact.vue?vue&type=template&id=8a4427d2&"
import script from "./CompanyClientContact.vue?vue&type=script&lang=js&"
export * from "./CompanyClientContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports